import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SistaPageLayout, SpravaTextuContextZone } from "@sista/fe-commons";
import { IdmClientContext } from "@sista/idm-client";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { useLocalNavigation } from "../../hooks/useLocalNavigation";
import { SpravaTextuAdminScreen } from "../../screens/SpravaTextuAdminScreen";
export const LoggedUserContent = () => {
    const { loggedAccount, roles } = useContext(IdmClientContext);
    const show = roles != null && loggedAccount != null;
    const localNavigationConfig = useLocalNavigation();
    return (_jsx(_Fragment, { children: _jsx(SistaPageLayout, { localNavigationConfig: localNavigationConfig, children: _jsx(SpravaTextuContextZone, { providerUrn: "urn:sista:providers:mzp", children: show && (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(SpravaTextuAdminScreen, {}) }), _jsx(Route, { path: "/:view/", element: _jsx(SpravaTextuAdminScreen, {}) }), _jsx(Route, { path: "/:view/:keyId", element: _jsx(SpravaTextuAdminScreen, {}) })] })) }) }) }));
};
